import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client';
import OrderApp from './Order/OrderApp';
import { theme } from './theme';

if (window.location.hostname === 'lunch-box.gr')
    window.location.href = 'https://lunch-box.gr/';


const container = document.getElementById('app');
const root = createRoot(container);
root.render(
    <ThemeProvider theme={theme}>
        <OrderApp />
    </ThemeProvider>
);

// Default export to fix Sentry warning
export default {};
